<template>
  <div class="card border-orange card-feedbacks">
      <div class="card-header custom-card-header border-none bg-secondary text-light font-weight-bold heading-primary">
           <span class="feedback-name">{{$t('provider_detail.feedback.name')}}</span>
           <FeedbackView class="float-right" :providerId="providerId" />
          <!-- <router-link class="float-right text-light font-weight-normal" :to="{ name: 'ProviderDetail' }"><span class="d-none d-lg-inline-block">View More</span> ></router-link> -->
      </div>
      <div v-if="services && services.length > 0" class="card-body custom-card-body">
          <div class="card-title m-0">
            <swiper class="swiperFeedbacks" :options="swiperFeedbacks">
                <swiper-slide v-for="(service) in services" :key="service._id">
                    <ul class="nav cusor-pointer" id="tab-feedback" role="tablist" @click="selectService(service._id)">
                        <li class="nav-item">
                          <a :title="service.category.name"  class="nav-link d-flex justify-content-center flex-column align-items-center text-center font-weight-bold text-secondary swiper-feedback" :class="{'active': selectedServiceId == service._id}" >
                            <span class="d-inline-block">{{translateCategory(service.category)}}</span>
                            <div class="d-inline">
                                <span class="fa fa-star"></span>
                                {{ caculateRating(service.totalStar, service.totalRate)}}/5
                            </div>
                          </a>
                        </li>
                    </ul>
                 </swiper-slide>
                 <div class="swiper-scrollbar-feedback" slot="scrollbar"></div>
             </swiper> 
          </div>
      </div>    
      <div class="tab-content">
          <div class="w-100 d-flex justify-content-center" v-if="loading">
               <span class="loading p-2" v-if="loading"></span>
          </div>
          <div class="w-100" v-else>

            <div class="mb-3 feedback-content" v-for="feedback in feedbacksByServiceId" :key="feedback._id">
              <div class="d-inline d-flex flex-row justify-content-between">
                    <div class="d-flex flex-row">
                        <img v-if="feedback.user && feedback.user.avatar"  class="feedback-avatar" :src="feedback.user.avatar" alt="image user"/>
                        <img v-else class="feedback-avatar" src="~@/assets/default-avatar.svg" alt="image user"/>
                        <div class="pl-2">
                              <div class="font-weight-bold text-word-break" v-if="feedback.user">{{feedback.user.displayName}}</div>
                              <star-rating  text-class="text-secondary font-weight-bold star-size" :show-rating="false" :star-size="13" :rating="feedback.star" :read-only="true" :increment="0.1">
                              </star-rating>
                        </div>
                      </div>
                    <div class="d-none d-lg-block">
                        {{ feedback.totalLike}} <i class="fas fa-thumbs-up"></i>
                    </div>
                </div>
                <div class="mt-2 pl-sm-5 pr-sm-5">
                    <div>
                        {{ feedback.comment }}
                    </div>
                    <span class="d-block text-date font-weight-normal mt-2">{{feedback.createdAt | dateTimeFormat}}</span>
                </div>
                <div v-if="feedback.reply">
                    <hr/>
                    <span class="font-weight-bold">{{$t('provider_detail.feedback.response')}}</span>
                    <div class="d-block text-date font-weight-normal mt-2 mb-2">{{feedback.updateAt | dateTimeFormat}}</div>
                    <div>{{feedback.reply}}</div>
                </div>
            </div>
            <div v-if="feedbacksByServiceId && feedbacksByServiceId.length <= 0 && !loading" class="mb-3 text-black feedback-content" >
                {{$t('provider_detail.feedback.none')}}
            </div>
          </div>
      </div>       
  </div>
</template>

<style scoped lang="scss">
 .card-feedbacks{
    font-size: 12px;
    .custom-card-header{
        padding: 10px 6px;
    }
    .custom-card-body{
        padding: 10px 6px;
    }
    .swiperFeedbacks{
        #tab-feedback{
            height: 100%;
            .nav-item {
                // height: 80px;
                height: 100%;
                width: 100%;
            }
            .nav-link{
                // font-size: .85rem;
                width: 100%;
                color: black;
                height: inherit;
                border-radius: 8px;
            }
            .nav-link.active{
                background-color: #FFBE17;
                font-weight: bold;
            }
      }
    }

    .swiper-slide {
      height: auto;
    }

    .swiper-scrollbar-feedback{
      cursor: pointer;
      left: 0;
      height: 6px;
      margin: 5px 0px;
    }

    .cusor-pointer{
      cursor: pointer;
    }  

    .feedback-name{
        font-size: 14px;
    }

    .feedback-avatar{
        border-radius: 14px;
        width: 40px;
        height: 40px;
    }

    .feedback-content {
      padding: 10px 6px;
    }
    .feedback-content:first-child {
      border-top: 1px solid #ffefc5;
    }
    .feedback-content:not(:last-child) {
      border-bottom: 1px solid #ffefc5;
    }
}
  .loading {
    margin: 20px;
    display: inline-block;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #ffbe17;
    width: 30px;
    height: 30px;
    -webkit-animation: spin 0.9s linear infinite;
    animation: spin 0.8s linear infinite;
  }
  @-webkit-keyframes spin {
      0% {
          -webkit-transform: rotate(0deg);
      }
      100% {
          -webkit-transform: rotate(360deg);
      }
  }

  @keyframes spin {
      0% {
          transform: rotate(0deg);
      }
      100% {
          transform: rotate(360deg);
      }
  }


  @media screen and (min-width: 1024px){
    .card-feedbacks{
      font-size: 14px;
      .feedback-name{
          font-size: 16px;
      }
      .custom-card-header{
        padding: 10px 15px;
      }
      .custom-card-body{
          padding: 10px 15px;
      }
      .feedback-content {
        padding: 10px 15px;
      }
    }
  }

</style>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import FeedbackView from "@/components/FeedbackView";
import StarRating from "vue-star-rating";
import moment from "moment";
export default {
  components:{
    FeedbackView,
    Swiper,
    SwiperSlide,
    StarRating
  },
  directives: {
    swiper: directive
  },
  props: {
    providerId: String,
    services: Array
  },
  data(){
    return{
      feedbacksByServiceId: [],
      selectedServiceId: null,
      // services: [],
      // feedbacks: [],
      loading: false,
      swiperFeedbacks: {
        scrollbar: {
          el: '.swiper-scrollbar-feedback'
        },
        spaceBetween: 5,
        breakpoints: {
          1200: {
            slidesPerView: 2,
            spaceBetween: 9
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 9
          },
          576: {
            slidesPerView: 1,
            spaceBetween: 9
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 9
          }
        }
      }
    }
  },
  filters: {
      dateTimeFormat(value) {
          return moment(value).format('DD/MM/YYYY');
      }  
  },
  methods: {
    translateCategory(category){
        if(localStorage && localStorage.language == 'vi'){
            return category.vietnameseName;
        }
        return category.name;
    },
    selectService(id){
        this.feedbacksByServiceId = [];
        this.selectedServiceId = id;
        this.getFeedbacksByServiceId(id).then(results =>{
          //  this.feedbacksByServiceId = results;
          const feedbacks = results.map( async feedback =>{
              const user = await this.getUserById(feedback.user);
              feedback.user = user[0];
              return feedback;
          });
          Promise.all(feedbacks).then(results => {
              this.feedbacksByServiceId = results;
          });
        });
    },

    caculateRating(totalStar, totalRate) {
      let results = totalStar / totalRate;
      if (totalStar == 0 && totalRate == 0) {
        return 0;
      }
      if (results % 1 != 0) {
        results = results.toFixed(1);
      }

      return Number(results);
    },
    // async getCategoryById(categoryId) {
    //   try {
    //     const {
    //       data: { results }
    //     } = await this.$store.$oddjob.settings.getCategoryById(categoryId);
    //     if (results && results.length > 0) {
    //       console.log('categoryById', results[0]);
    //       return results[0];
    //     }
    //     return {};
    //   } catch (e) {
    //     console.log("API category failed");
    //   }
    // },
    async getUserById(userId) {
      try {
        const {
          data: { results }
        } = await this.$store.$oddjob.users.getUserById(userId);
        if (results && results.length > 0) {
          this.loading = false;
          return results;
        }
        this.loading = false;
        return [];
      } catch (e) {
        console.log("API get user failed", e);
      }
    },
    // async getFeedbacksByServiceId(serviceId) {
    //   this.loading = true;
    //   const {
    //     data: { results }
    //   } = await this.$store.$oddjob.serviceProviders.getFeedbackByServiceId(
    //     serviceId
    //   );
    //   if (results && results.length > 0) {
    //       const feedbacks = results.map(async feedback => {
    //       const results = await this.getUserById(feedback.user);
    //       feedback.user = results[0];
    //       return feedback;
    //     });
    //     return Promise.all(feedbacks);
    //   }
    //   this.loading = false;
    //   return [];
    // },
    async getFeedbacksByServiceId(serviceId) {
        this.loading = true;
        const {
          data: { results }
        } = await this.$store.$oddjob.serviceProviders.getFeedbackByServiceId(
          serviceId
        );
        if (results && results.length > 0) {
           return results;
        }
        this.loading = false;
        return [];
    }

    // async getServicesByProviderId(providerId) {
    //   try {
    //     const {
    //       data: { results }
    //     } = await this.$store.$oddjob.serviceProviders.getServicesByProviderId(
    //       providerId
    //     );
    //     if (results && results.length > 0) {
    //       const data = results.map(async service => {
    //         service.category = await this.getCategoryById(service.category);
    //         return service;
    //       });
    //       return Promise.all(data);
    //     }
    //     return [];
    //   } catch (e) {
    //     console.log("API service failed", e);
    //   }
    // }

  },
  async mounted() {
    //  this.services = await this.getServicesByProviderId(this.providerId);
     if(this.services && this.services.length > 0){
        this.selectService(this.services[0]._id);
        this.feedbacksByServiceId = await this.getFeedbacksByServiceId(this.selectedServiceId);
     }
  }
}
</script>


